<template>
  <div v-if="hasMenu()">
    <div style="margin: 5px 0; border-top: 1px solid rgba(255,255,255, 0.2);width: 100%;" v-if="hasTopSeparator()"></div>
    <router-link :to="{name: module.sideMenu.routeName,  params: module.sideMenu.routeParams}" v-if="!hasSubLinks() && !notCustomerRate()">
      <el-menu-item :index="module.sideMenu.caption" @click="linkClicked">
        <i :class="module.sideMenu.icon" style="color: #fff;font-size: 9pt"></i>
        <span style="font-size: 9pt">{{ module.sideMenu.caption == "Customers Rates" ? "Cutomers" : module.sideMenu.caption }}</span>
      </el-menu-item>
    </router-link>
    <el-submenu :index="module.sideMenu.caption" v-else-if="!notCustomerRate() && !notVOSserver()" >
      <template slot="title">
        <i :class="module.sideMenu.icon" style="color: #fff;font-size: 9pt"></i>
        <span class="title" style="font-size: 9pt">{{ module.sideMenu.caption }}</span>
      </template>

      <router-link :key="subMenuKey"
                   :to="{name: subMenu.routeName, params: subMenu.routeParams}" v-for="(subMenu, subMenuKey) in menuChildren">
        <el-menu-item :index="subMenu.caption + '-' + module.sideMenu.caption" @click="linkClicked" class="ml-2" v-if="isSubMenuAllowed(subMenu)">
          <i :class="subMenu.icon" style="color: #fff;font-size:11pt"></i>
          <span slot="title" style="font-size: 9pt">{{ subMenu.caption }}</span>
        </el-menu-item>
      </router-link>
    </el-submenu>
  </div>
</template>

<script>
export default {
  props: {
    groups: {
      required: true
    },
    module: {
      required: true
    },
    userProfileId: {
      required: true
    }
  },
  data() {
    return {
      menuChildren: [],
    }
  },
  mounted() {
    // Always place modules in their specified group without profile checks
    if (this.module.info.hasOwnProperty('viewGroup')) {
      let moduleGroup = this.module.info.viewGroup
      let groupContainer = document.getElementById('side-menu-view-group-' + moduleGroup + '-children')
      
      if (groupContainer) {
        groupContainer.appendChild(this.$el)
      }
    }
  },
  beforeMount:{

  },
  methods: {
    isSubMenuAllowed(subMenu) {
      // Show all sub-menu items - let backend control via login response
      return true;
    },
    linkClicked () {
      this.$store.state['side-nav-state'].isCollapsed = true
    },
    hasSubLinks() {
      if (this.module.sideMenu.hasOwnProperty('children')) {
        this.menuChildren = this.module.sideMenu.children
        return true
      }
      return false
    },
    hasMenu() {
      // Show all modules that have sideMenu property - let backend control via login response
      return this.module.hasOwnProperty('sideMenu');
    },
    hasTopSeparator() {
      return this.module.sideMenu.hasOwnProperty('topSeparator') && this.module.sideMenu.topSeparator;
    },
     notCustomerRate(){
      // Show all modules - let backend control via login response
      return false;
    },
     notVOSserver(){
      // Show all modules - let backend control via login response
      return false;
    },
    //  notLCR(){
      
    //   return this.module.sideMenu.caption == 'LCR Table' && this.userProfileId == 6 ;
    // },
  }
}
</script>
